
<plp-components-shipping-option-button [shippingOption]="exposedFilter()"></plp-components-shipping-option-button>
